// Diseno unico de los avisos (SweetAlert2) de ZOCO.
//
// Los avisos se disparan desde muchas pantallas, cada una con su propio
// Swal.fire({...}) y el diseno viejo (logo arriba, boton verde). En lugar de
// editar cada llamada, aca se intercepta Swal.fire una sola vez y se cambia
// SOLO la presentacion (icono, clases, texto del boton "Ok"). Titulos, textos,
// botones y lo que hace cada pantalla despues (.then, timer,
// allowOutsideClick, etc.) quedan igual.
//
//   - "Sesion expirada / invalida" (cualquier seccion): pasa a
//     "Tu sesion finalizo" con el diseno nuevo.
//   - Cualquier otro aviso dentro de /aliados/: diseno nuevo, mismos textos.
//   - El aviso "Tu sesion esta por vencer" (useSessionGuard.js) usa
//     directamente CLASES_ALERTA_ZOCO.
//
// No se tocan: avisos con diseno propio (customClass.popup, p. ej. el de
// "Cerrar sesion"), toasts, ni avisos fuera de Aliados.
//
// Se importa una vez desde index.js.
import Swal from "sweetalert2";
import "./alertasZoco.css";

export const CLASES_ALERTA_ZOCO = {
  container: "zoco-alerta-swal",
  popup: "zoco-alerta-swal__popup",
  icon: "zoco-alerta-swal__icon",
  title: "zoco-alerta-swal__title",
  htmlContainer: "zoco-alerta-swal__text",
  actions: "zoco-alerta-swal__actions",
  confirmButton: "zoco-alerta-swal__confirm",
  denyButton: "zoco-alerta-swal__cancel",
  cancelButton: "zoco-alerta-swal__cancel",
};

export const ICONO_ALERTA_ZOCO = "#b4c400";

const TITULO_SESION_VENCIDA = /^\s*sesi\S{1,2}n\s+(expirada|inv\S{1,2}lida)/i;

// Presentacion vieja que se descarta al redisenar.
const CLAVES_DE_PRESENTACION = [
  "icon",
  "iconColor",
  "iconHtml",
  "imageUrl",
  "imageWidth",
  "imageHeight",
  "imageAlt",
  "customClass",
  "buttonsStyling",
];

const esObjeto = (valor) => valor !== null && typeof valor === "object";

const estaEnAliados = () =>
  typeof window !== "undefined" &&
  window.location.pathname.toLowerCase().startsWith("/aliados/");

const tieneDisenoPropio = (opciones) => {
  const clases = opciones.customClass;
  if (!esObjeto(clases)) return false;
  return Boolean(clases.popup) || /logout-confirmation|zoco-alerta/.test(String(clases.container || ""));
};

const textoBoton = (texto) =>
  typeof texto === "string" && /^\s*ok\s*$/i.test(texto) ? "Aceptar" : texto;

const sinPresentacion = (opciones) => {
  const copia = { ...opciones };
  CLAVES_DE_PRESENTACION.forEach((clave) => delete copia[clave]);
  return copia;
};

const redisenar = (opciones) => ({
  ...sinPresentacion(opciones),
  icon: opciones.icon === "success" ? "success" : "warning",
  iconColor: ICONO_ALERTA_ZOCO,
  confirmButtonText: textoBoton(opciones.confirmButtonText) || "Aceptar",
  // cancelar/cerrar a la izquierda (gris) y la accion principal a la derecha
  reverseButtons: opciones.reverseButtons ?? true,
  buttonsStyling: false,
  customClass: CLASES_ALERTA_ZOCO,
});

const sesionFinalizada = (opciones) => ({
  ...sinPresentacion(opciones),
  icon: "warning",
  iconColor: ICONO_ALERTA_ZOCO,
  title: "Tu sesión finalizó",
  text: "Para proteger tu cuenta, volvé a iniciar sesión para continuar.",
  html: undefined,
  confirmButtonText: "Ingresar",
  showCancelButton: false,
  showDenyButton: false,
  buttonsStyling: false,
  customClass: CLASES_ALERTA_ZOCO,
});

const fireOriginal = Swal.fire.bind(Swal);

Swal.fire = (...args) => {
  const [opciones] = args;
  if (args.length !== 1 || !esObjeto(opciones) || opciones.toast) {
    return fireOriginal(...args);
  }

  if (typeof opciones.title === "string" && TITULO_SESION_VENCIDA.test(opciones.title)) {
    return fireOriginal(sesionFinalizada(opciones));
  }

  if (estaEnAliados() && !tieneDisenoPropio(opciones)) {
    return fireOriginal(redisenar(opciones));
  }

  return fireOriginal(...args);
};
